import { Ajax } from "../utils/base";
import IP from "../config/config"
// const DC = process.env.VUE_APP_DC;
// const NEWS = process.env.VUE_APP_NEWS;
// 模型聚合页入口列表
export function getTransferWx (params) {
    const url = IP.mApis() + `/passport/pay/transfer/wx/${params.trade_no}`;
    return Ajax(url, null, "GET")
}
